import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How does the MPillar AIQR Kit work?',
      answer: 'It\'s simple! Place the QR stand on your counter or stick the QR stickers at visible locations. When customers scan the QR code with their phone camera, WhatsApp opens automatically with a pre-filled message. They send it, and you receive their contact. Now you can message them anytime with offers, updates, and stay connected!'
    },
    {
      question: 'Do I need any technical knowledge to set this up?',
      answer: 'Absolutely not! Setup takes just 30 seconds. We provide a simple setup guide and video tutorial. Just scan your own QR code, save the template, and you\'re ready to go. No coding, no complicated software - it just works!'
    },
    {
      question: 'Will this work with my existing WhatsApp number?',
      answer: 'Yes! The kit works perfectly with your existing WhatsApp Business or regular WhatsApp number. You don\'t need to change numbers or download any new apps. It seamlessly integrates with what you already use.'
    },
    {
      question: 'Is there a monthly subscription fee?',
      answer: 'No! This is a one-time payment of ₹1,999. No monthly fees, no hidden charges, no subscriptions. You own the kit forever and can use it as long as you want without any additional costs.'
    },
    {
      question: 'What if customers don\'t have WhatsApp?',
      answer: 'WhatsApp is the most popular messaging app in India with over 500 million users. Almost everyone has it! But even if 1-2% don\'t, you\'ll still capture 98% of your walk-in customers - that\'s a huge database!'
    },
    {
      question: 'How many contacts can I collect?',
      answer: 'Unlimited! There\'s no limit to how many customer contacts you can collect. Whether it\'s 100 or 10,000 customers, the kit works the same way. Your database grows with your business.'
    },
    {
      question: 'What is the 30-day money-back guarantee?',
      answer: 'If you\'re not satisfied with the kit for any reason within 30 days of receiving it, just contact our support team. We\'ll refund your full amount - no questions asked. We want you to be 100% happy with your purchase!'
    },
    {
      question: 'How long does delivery take?',
      answer: 'We deliver across India within 3-5 business days. You\'ll receive a tracking number once your order is shipped. For metro cities, delivery is often faster (2-3 days).'
    },
    {
      question: 'Can I customize the QR code message?',
      answer: 'Yes! You can customize what message customers see when they scan. Add a welcome message, promote a special offer, or just ask them to connect. Full customization is included in your kit setup.'
    },
    {
      question: 'Do you provide customer support?',
      answer: 'Absolutely! We offer 24/7 customer support via WhatsApp and email. Whether you need help with setup, customization, or have any questions - our team is always ready to help you succeed.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Got questions? We've got answers!
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-50 rounded-lg overflow-hidden border border-gray-200">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-100 transition-colors"
              >
                <span className="font-semibold text-gray-900 pr-4">{faq.question}</span>
                <span className="text-green-500 text-2xl flex-shrink-0">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-4 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Still have questions?</p>
          <a 
            href="mailto:support@mpillar.com" 
            className="inline-block bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors"
          >
            Contact Our Support Team
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;